<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
}
html,body{
  height: 100%;
}
body{
  height: auto;
  width:100%;
  position:relative;
  margin: 0;
  padding: 0;
}
.el-menu--horizontal.user-submenu{
  width: 350px;
}
.el-menu--horizontal.user-submenu ul{
    width: 124px;
    padding: 0 10px;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue